import { useCallback, useRef } from 'react';

import { toggleValueInSet } from 'utility/Toggle/toggleValueInSet';

interface UseListNavigationProps<Type> {
    toggleMultiple?: boolean;
    defaultValues?: Set<Type>;
}

export const useListNavigation = <Type>({
    toggleMultiple = false,
    defaultValues = new Set(),
}: UseListNavigationProps<Type>) => {
    const selectedValues = useRef<Set<Type>>(defaultValues);

    return useCallback(
        (value: Type) => {
            if (selectedValues.current.has(value)) {
                if (toggleMultiple) {
                    selectedValues.current = toggleValueInSet(
                        selectedValues.current,
                        value
                    );
                } else {
                    selectedValues.current = new Set();
                }
            } else {
                if (toggleMultiple) {
                    selectedValues.current = toggleValueInSet(
                        selectedValues.current,
                        value
                    );
                } else {
                    selectedValues.current = new Set([value]);
                }
            }
            return selectedValues.current;
        },
        [toggleMultiple]
    );
};
